import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDidMount } from 'rooks';
import {
	Button,
	CustomScrollbars,
	FixedButtons,
	Icon,
	Loader,
	ModuleHeader,
	ModuleTopBar,
} from '../../components';
import {
	changeActiveTest,
	checkArchiveTests,
	createTest,
	deleteTest,
	fadeInModule,
	getArchiveTests,
	getUserTests,
	sortTests,
} from '../../redux/actions';
import colors from '../../utils/colors';
import SingleTest from './SingleTest';
import './style.scss';

function TestListModule() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	//loader state - true until data is loaded
	const [isLoading, setLoading] = useState(true);

	//searchbox filter
	const [filter, setFilter] = useState(new RegExp('', 'gi'));

	const tests = state.tests;
	const activeTest = tests.activeTest;
	const testList = tests.testList;
	const mobileActive = state.filter.mobileActive || state.editor.mobileActive;

	const handleCreateTest = () => {
		dispatch(createTest(state.user.id));
	};

	const handleGetArchiveTests = () => {
		dispatch(getArchiveTests(state.user.id));
	};

	//check for user archive tests
	useEffect(() => {
		// TODO: sprawdzić czy nie można tego usprawnić
		if (state.user.id) {
			dispatch(checkArchiveTests(state.user.id));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.user]);

	useDidMount(() => {
		dispatch(fadeInModule('test-list'));
	});

	useEffect(() => {
		if (state.user.id) {
			dispatch(getUserTests(state.user.id));
		}
	}, [state.user.id, dispatch]);

	useEffect(() => {
		const loading = setTimeout(() => {
			//db loading simulation
			setLoading(false);
		}, 1000);

		return () => {
			clearTimeout(loading);
		};
	}, [testList.length, dispatch, state.user.id, state.app.apiError]);

	const handleDeleteTest = (id) => {
		dispatch(
			deleteTest(
				testList.find((test) => test['id_testu'] === id),
				state.user.id
			)
		);
	};
	const handleFilterTests = (e) => {
		if (e.target.value.match(/[a-z0-9]/gi) !== null) {
			setFilter(new RegExp(e.target.value.match(/[a-z0-9]/gi).join(''), 'gi'));
		} else {
			setFilter(new RegExp(''));
		}
	};

	const parsedTests = useMemo(() => {
		return testList
			.filter((test) => test.nazwa.match(filter) || test.przedmiot.match(filter))
			.sort((a, b) => (tests.sortDesc ? b.dataUnix - a.dataUnix : a.dataUnix - b.dataUnix));
	}, [tests, testList, filter]);

	return (
		<section className={`module-mytests ${tests.isHidden ? 'hidden' : ''}`}>
			<ModuleTopBar>
				<form onSubmit={(e) => e.preventDefault()} autoComplete="off">
					<input
						type="text"
						name="taskName"
						id="taskName"
						placeholder="Wyszukaj test"
						autoComplete="off"
						onChange={handleFilterTests}
					/>
					<Button color="transparent text-white">
						<span className="btn-label">Szukaj</span>
						<Icon name="search" width="16px" height="16px" color={colors.white} />
					</Button>
				</form>
			</ModuleTopBar>
			<ModuleHeader>
				<span className="myTests-header-info">
					{isLoading ? 'Ładowanie testów...' : `Znaleziono ${parsedTests.length} testów`}
				</span>
				<span className="test-sort-btn">
					<Button
						color="transparent text-grey-black"
						onClick={() => dispatch(sortTests(!tests.sortDesc))}
					>
						sortuj wg daty
						<Icon
							name={tests.sortDesc ? 'chevron-down' : 'chevron-up'}
							color={colors.greyDark}
							width="14"
							height="14"
						/>
					</Button>
				</span>
			</ModuleHeader>
			<CustomScrollbars autoHide>
				<div className="mytests-list">
					{isLoading ? (
						<div className="mytests-preloader">
							<Loader type="roller" />
						</div>
					) : tests.testList.length > 0 ? (
						parsedTests.map((test) => (
							<SingleTest
								key={test['id_testu'] || test.id}
								test={test}
								active={activeTest === test['id_testu'] || activeTest === test.id}
								handleDelete={handleDeleteTest}
								onClick={() => {
									dispatch(changeActiveTest(test, state.app.isMobileSize));
								}}
							/>
						))
					) : (
						<p className="mytests-placeholder">
							Brak zapisanych testów. Kliknij poniżej aby utworzyć nowy test
						</p>
					)}
				</div>
			</CustomScrollbars>

			<footer className="mytests-footer">
				<Button
					className={`${!state.tests.hasArchiveTests ? 'hidden' : ''}${
						state.tests.isLoadingArchiveTests ? ' disabled' : ''
					}`}
					color="transparent text-primary"
					onClick={handleGetArchiveTests}
				>
					pobierz archiwalne testy
					{state.tests.isLoadingArchiveTests ? (
						<Icon name="spinner" width="13" height="13" />
					) : (
						<Icon name="download" width="13" height="13" color={colors.greenDark} />
					)}
				</Button>
				<Button color="secondary text-white" onClick={handleCreateTest}>
					stwórz nowy test
					<Icon name="plus" width="13" height="13" color={colors.white} />
				</Button>
			</footer>
			{state.app.isMobileSize &&
				(!mobileActive ? (
					<FixedButtons>
						<Button
							className={`${!state.tests.hasArchiveTests ? 'hidden' : ''}${
								state.tests.isLoadingArchiveTests ? ' disabled' : ''
							}`}
							color="white text-primary"
							onClick={handleGetArchiveTests}
						>
							pobierz archiwalne testy
							{state.tests.isLoadingArchiveTests ? (
								<Icon name="spinner" width="13" height="13" color={colors.greenDark} />
							) : (
								<Icon name="download" width="13" height="13" color={colors.greenDark} />
							)}
						</Button>
						<Button color="secondary text-white" onClick={handleCreateTest}>
							nowy test
							<Icon name="plus" width="13" height="13" color={colors.white} />
						</Button>
					</FixedButtons>
				) : undefined)}
		</section>
	);
}

export default TestListModule;
